import { generateErrors } from 'utilities/util';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { TYPES } from 'action-types/customerToggle';
import { callApiGet } from 'utilities/apiCaller';
import API from 'constants/api';

export const fetchCustomerToggles = (customerBeCode: string) => {
	return async (dispatch: ThunkDispatch<any, any, Action>) => {
		dispatch({ type: TYPES.FETCH_CUSTOMER_TOGGLES_DATA.PENDING });
		try {
			const res = await callApiGet(
				`${API.FinanceConfig.GetCustomerToggles}`,
				{ customerBeCode },
			);
			dispatch({
				type: TYPES.FETCH_CUSTOMER_TOGGLES_DATA
					.FULFILLED,
				customerToggle: res.data.data,
			});
		} catch (e) {
			const errors = generateErrors(e);
			dispatch({
				type: TYPES.FETCH_CUSTOMER_TOGGLES_DATA
					.REJECTED,
				errors,
			});
		}
	};
};
